// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3Oc1o","left":"InfoRow_left__vJ3r5"};